import { CursorArrowRaysIcon } from "@heroicons/react/24/outline";

export default function BrowseActionsScene({ className = "" }: { className?: string }) {
  return (
    <div
      className={`relative flex w-60 flex-col gap-2 rounded-xl border border-primary/20 bg-primary/5 p-3 ${className}`}
      aria-hidden="true"
    >
      <div className="flex items-center gap-2">
        <div className="h-2 w-8 rounded-full bg-primary/25" />
        <div className="h-2 w-12 rounded-full bg-primary/15" />
      </div>
      <div className="relative flex h-9 items-center rounded-lg border-2 border-primary/45 bg-white px-2.5">
        <div className="h-2 w-14 rounded-full bg-primary/20" />
        <div className="ml-1 h-3.5 w-0.5 animate-pulse bg-primary" />
        <CursorArrowRaysIcon className="absolute -bottom-2 right-2 h-8 w-8 text-gray-800 drop-shadow-sm" />
      </div>
      <div className="flex h-7 items-center rounded-lg border border-primary/15 bg-white/70 px-2.5">
        <div className="h-2 w-16 rounded-full bg-primary/10" />
      </div>
    </div>
  );
}
